module.exports = __webpack_public_path__ + "img/HZGB02-02-08.f2dd11d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB02-02-08.png
// module id = YPho
// module chunks = 0